<template>
  <!-- 维修站验证 -->
  <div class="register-page ">
    <!-- <div class="content" v-show="false">
      <van-form @submit="onSubmit" :show-error="false">
        <van-field v-model="clientInfo.clientName" name="维修站名称" label="维修站名称" placeholder="点击填写维修站名称"
          :rules="[{ required: true, message: '请输入维修站名称' }]" disabled />
        <van-field v-model="clientInfo.detailAddress" name="维修站地址" label="维修站地址" placeholder="点击填写维修站地址"
          :rules="[{ required: true, message: '请输入维修站地址' }]" disabled />
        <van-field :value="clientInfo.contactMobile + '(' + kongzTokenDTO.name + ')'" name="维修站手机号" label="维修站手机号"
          :rules="[{ required: true, message: '请输入手机号' }]" disabled>
        </van-field>
        <div class="confirmButton">
         <van-button  block type="primary" native-type="submit">确认{{ fixedButtonText }}
          </van-button>
        </div>
      </van-form>
    </div> -->
  </div>
</template>

<script>
// import countdownButton from './countdown-button.vue'
// import kangzhongApi from '@/api/bind'
export default {
  components: {
    // countdownButton
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => { }
    },
    kongzTokenDTO: {
      type: Object,
      default: () => { }
    },
    fixedButtonText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      verifyCode: '' // 验证码
    }
  },
  mounted () {
    this.onSubmit()
  },
  computed: {},
  methods: {
    // getCode (phone) {
    //   if (!this.$refs.countDown.isGeting && phone.trim()) {
    //     kangzhongApi.getVerifyCode({ phone: phone.trim() }).then(res => {
    //       if (res.data.resultCode === '0') {
    //         this.$toast('已发送验证码')
    //         this.$refs.countDown.startDown()
    //       }
    //     })
    //   }
    // },
    onSubmit () {
      let data = {
        uuid: this.kongzTokenDTO.uuid,
        phone: this.clientInfo.contactMobile,
        name: this.kongzTokenDTO.name,
        // verifyCode: this.verifyCode,
        clientName: this.clientInfo.clientName,
        detailAddress: this.clientInfo.detailAddress,
        provinceName: this.clientInfo.provinceName,
        cityName: this.clientInfo.cityName,
        countyName: this.clientInfo.countyName,
        userRole: this.kongzTokenDTO.userRole,
        clientCode: this.clientInfo.clientCode
      }
      this.$emit('submit', data)
    }
  }
}
</script>
<style  scoped lang="less">
.register-page {
  .content {
    background-color: #fff;
  }

  .van-cell {
    background-color: #fff;

    /deep/ .van-field__label {
      width: 100%;
    }
  }
}

.confirmButton {
  padding: 0.5rem;
}
</style>
